import { all } from 'async-saga';
import { routerActions } from 'connected-react-router';
import { Dispatch } from 'react';
import { isMobile } from 'react-device-detect';
import { AnyAction } from 'redux';
import { actions } from '..';
import * as api from '../../api';
import { hold, resume } from '../../api/call-control';
import { IpcRenderSendAdminStart, IpcRenderSendAdminStop, IpcRenderSendClientIntegrated, IpcRenderShowMainWindow } from '../../Electron/ipcCommands';
import { activeCallCount } from '../../Components/CallPopup';
import { GetCallControl } from '../../Components/MainToolbarDialButton';
import { openSmartSearchDialogTeams, showPresenceDialog, SmartSearchAction } from '../../legacy';
import { DeviceGroupType, Extension, ExtensionDevice, ExtensionStatus, Identifier, Presence } from '../../model';
import { selectActiveDevice } from '../reducers';
import { getConfig, MyData, MyDevices, selectIsWebRtcEnabled, selectMyAccess, selectMyData, selectMyDevices, selectMyself } from '../reducers/config';
import { getParkedMedia, selectedTableRowDialNumber, selectInIpfxClient } from '../reducers/localSettings';
import { selectHeldCall, selectMyActiveCall, selectMyCalls, selectQueueHeldCall } from '../reducers/media';
import { selectExtension } from '../reducers/queueAgents';
import { takeEvery } from '../tools/async-saga-types';

const onSetDefaultPresence = takeEvery(actions.setPresence, (ctx, { extension, presence, type, breakCode }) => api.setDefaultPresence(extension, presence, type, breakCode))
const setWorkTime = takeEvery(actions.setWorkTime, (ctx, payload) => api.setWorkTime(payload))
const setAwayFromDesk = takeEvery(actions.setAwayFromDesk, (ctx, payload) => api.setAwayFromDesk(payload))

const setCallback = takeEvery(actions.setCallback, async (ctx, { ext, callback }) => {
  if (callback) {
    await api.setCallback(ext)
  }
})

const onWindowKeyDown = takeEvery(actions.windowKeyDown, async (ctx, { keyCode }) => {
  const store = ctx.getState()
  const access = selectMyAccess(store)
  const myId = selectMyself(store)
  const me = selectMyData(store)
  const extension = myId && selectExtension(store, myId)
  const devices = selectMyDevices(store)
  const activeDevice = selectActiveDevice(store)
  const activeCall = selectMyActiveCall(store)
  const number = selectedTableRowDialNumber(store)
  if (!myId || !extension || !devices || !access || !me || !activeDevice) return

  switch (keyCode) {
    case 192:
    case 223:

      let action = 'dial'
      if (extension.status === ExtensionStatus.Released || extension.status === ExtensionStatus.None) {
        action = 'dial'
      } else {
        action = 'blind-transfer'
      }

      openSmartSearch(number, action as SmartSearchAction, devices, activeDevice, me, extension, ctx.dispatch)
      break
    case 109: //'-'
      if (extension.status === ExtensionStatus.Answered) {
        openSmartSearch(number, 'blind-transfer', devices, activeDevice, me, extension, ctx.dispatch)
      }
      break
    case 107: //'+'
      if (extension.status === ExtensionStatus.Ringing) {
        ctx.dispatch(actions.ccAnswerMedia(activeDevice, activeCall))
      } else if (extension.status === ExtensionStatus.Hold) {
        resume(activeDevice.number)
      } else if (extension.status === ExtensionStatus.Answered) {
        hold(activeDevice.number)
      }
      break
    case 110: //'. Del'
      ctx.dispatch(actions.ccHangUp(activeDevice.number, activeCall))
      break
    case 13: // enter
      /*
        if (access.features.phoneDial && extension.status === ExtensionStatus.None || extension.status === ExtensionStatus.Released) {
  
          if (number) {
            ctx.dispatch(actions.ccDial(number));
          } else {
            openSmartSearch('', 'dial', devices, activeDevice, me, extension, ctx.dispatch)
          }
        }
        */
      break
  }

  function openSmartSearch(number: string, action: SmartSearchAction, devices: MyDevices, activeDevice: ExtensionDevice, me: MyData, myExtension: Extension, dispatch: Dispatch<AnyAction>) {
    const calls = selectMyCalls(store)
    const callCount = activeCallCount(calls, devices.devices)
    const heldCall = selectHeldCall(store)
    const queueHoldMedia = selectQueueHeldCall(store)
    const parked = getParkedMedia(store)

    const control = GetCallControl(activeCall, heldCall, activeDevice, callCount, queueHoldMedia, parked, false,
      {
        access: access,
        mobile: me.mobile,
        associate: me.associate,
        status: myExtension.status,
        canReceiveVoicemail: me.canReceiveVoicemail,
        devices: devices.devices,
      })

    const inSupervisedTransfer = control.cancelTransfer.enabled

    ctx.dispatch(actions.openSmartSearch(action, myExtension.status, myExtension.subStatus, activeDevice.number, inSupervisedTransfer, activeCall, number))
  }
})

const onSetInIpfxElectron = takeEvery(actions.setInIpfxElectron, async (ctx, payload) => {
  const store = ctx.getState()
  const access = selectMyAccess(store)
  const config = getConfig(store)
  const extension = config && selectExtension(store, { id: config.extension, server: config.serverName })

  console.info('config [' + config + '] extension [' + extension + '] ipfx client [' + payload + ']')
  if (config && extension) {
    if (payload) {
      console.info('access.isTeamsPbx [' + access.isTeamsPbx + '] config.teamsEnhancedCti [' + config.teamsEnhancedCti !== undefined + ']')
      if (access.isTeamsPbx && config.teamsEnhancedCti !== undefined) {
        IpcRenderSendClientIntegrated(config.teamsEnhancedCti)
      }

      console.info('access.features.configQueues [' + access.features.configQueues + '] access.features.toolbarDashboard [' + access.features.toolbarDashboard + ']')
      if (access.features.configQueues || access.features.toolbarDashboard || access.isScreenRecording || access.features.toolbarConfiguration) {
        const temp = await api.getTemporaryPasswordForSession()
        IpcRenderSendAdminStart(config.extension, temp)
      } else {
        IpcRenderSendAdminStop()
      }
    }

    if (access.isTeamsPbx) {
      if (extension.presence !== Presence.Available && extension.presence !== Presence.Queue && extension.deviceGroupType === DeviceGroupType.Desk) {
        if (selectIsWebRtcEnabled(store))
          api.setDefaultPresence({ id: config.extension, server: config.serverName }, Presence.Available)
      }
    }
  }
})

const onOpenSetPresence = takeEvery(actions.openSetPresence, async (ctx, { id }) => {
  if (isMobile) {
    ctx.dispatch(routerActions.replace('/presence/' + id.id + '/' + id.server))
  } else {
    showPresenceDialog(id)
  }

})

const onOpenSmartSearch = takeEvery(actions.openSmartSearch, async (ctx, { control, status, subStatus, device, supperTrasnfer, call, searchQuery }) => {
  const store = ctx.getState()
  const myId = selectMyself(store)
  const devices = selectMyDevices(store)
  const ipfxClient = selectInIpfxClient(store)

  if (!devices || !myId) return

  if (ipfxClient) {
    IpcRenderShowMainWindow()
  }

  openSmartSearchDialogTeams(control,
    { id: myId.id, server: myId.server },
    status,
    subStatus,
    device,
    supperTrasnfer,
    call,
    searchQuery,
    (action, type, entityId, number) => {
      switch (action) {
        case 'dial':
          ctx.dispatch(actions.ccDial(number))
          break;
        case 'instantmessage':
          if (entityId !== null)
            ctx.dispatch(actions.requestOneOnOneConversation(entityId as Identifier, type))
          break;
        case 'hold-for':
          if (call)
            ctx.dispatch(actions.ccHoldFor(call.id))
      }
    })
})

const onSetFocus = takeEvery(actions.setFocus, async (ctx, payload) => {
  if (payload === true) {
    const store = ctx.getState()
    const config = getConfig(store)

    if (!config) return

    try {
      //checking session
      console.info('ping')
      api.ping(config.clientId)
    } catch (e) {
      api.processApiError(e, ctx.dispatch)
    }
  }
})

const onDownloadFile = takeEvery(actions.downloadFile, async (ctx, { url, preview, name }) => {
  const link = document.createElement('a');
  link.href = url;
  if (preview) {
    link.target = '_blank'
  } else {
    link.download = name
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
})

export default all(
  onSetDefaultPresence,
  setWorkTime,
  setAwayFromDesk,
  setCallback,
  onWindowKeyDown,
  onSetInIpfxElectron,
  onOpenSetPresence,
  onOpenSmartSearch,
  onSetFocus,
  onDownloadFile,
)
